<template>
  <div id="app">
    <httpPolling></httpPolling>
    <router-view></router-view>
    
  </div>
</template>

<script>
import httpPolling from './common/comHttpPolling.vue'
var opt;
export default {
  name: 'App',
  components: {
    httpPolling
  },
}
</script>

<style>
.popup{
  position: fixed;
  bottom: 1rem;
  right: 1rem;
  z-index: 11;
  background: red;
  display: block;
  height:1rem;
  width: 1rem; 
}
#app {
  width: 100%;
  height: 100%;
  overflow-y: scroll;
  background-color:#f7f8fa;
  position: relative;
}
</style>
